import { css, styled, Typography } from '@mui/material';

const PrivacyTypography = styled(Typography)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacing(2)};
  `,
) as typeof Typography;

export default PrivacyTypography;
